export const COLUMN_WIDTH: { [x: string]: string } = {
    ["Special"]: "0 20 22%",
    ["Activity"]: "0 20 20%",
    ["Listings"]: "10 10 8%",
    ["Date and Time"]: "0 20 28%",
    ["Views"]: "0 20 7%",
    ["Engagement"]: "0 20 15%",
}

export const DEFAULT_PAGE_SIZE = 10;
export const CHIPS_NUMBER=2;